/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Card,
  Box,
  FormGroup,
  FormControlLabel,
  Checkbox
} from '@mui/material';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
import { httpRequest } from 'src/services/httpRequest';
import FormikForm from 'src/ui-component/FormikFormLibrary';
import { Fields } from 'src/ui-component/FormikFormLibrary/FormikTypes';

type AddNewDepartmentProps = {
  setDepartmentAction: Dispatch<SetStateAction<string>>;
  departmentAction: any;
  handleApiCall: () => void;
};

const AddDepartment: React.FC<AddNewDepartmentProps> = ({
  setDepartmentAction,
  departmentAction,
  handleApiCall
}) => {
  const [allDepartmentData, setAllDepartmentData] = useState([]);
  const [filteredDepartmentName, setFilteredDepartmentName] = useState([]);
  const initialValue = {
    logo: useSelector((store: RootState) => store.theme.themeLogo),
    colour: useSelector((store: RootState) => store.theme.themeColor)
  };

  // Fetch all departments
  useEffect(() => {
    const getAllDepartments = async () => {
      const response = await httpRequest('GET', '/townships/departments');
      const departments = response?.data?.Data;
      setAllDepartmentData(departments);
      const departmentData = departments.map((item) => item.DepartmentName);
      setFilteredDepartmentName(departmentData);
    };
    getAllDepartments();
  }, []);

  // Form fields using Formik
  const allFields: Fields[] = [
    {
      fieldName: 'DepartmentName',
      fieldLabel: 'Department Name',
      fieldType: 'text',
      required: true,
      heading: 'Department Details',
      initialValue: departmentAction?.DepartmentName || ''
    },
    {
      fieldName: 'uploadLogo',
      fieldLabel: 'Upload Logo ',
      fieldType: 'file',
      initialValue: initialValue.logo
    },
    {
      fieldName: 'DepartmentDescription',
      fieldLabel: 'Department Description',
      fieldType: 'note',
      required: true,
      initialValue: departmentAction?.Description || ''
    }
  ];

  // Handle form submit
  async function handleSubmit(value: any) {
    let payload = {};
    if (departmentAction === 'Add') {
      payload = {
        PermitName: value?.PermitName,
        Department: {
          DepartmentID:
            (
              allDepartmentData.find(
                (dep) => dep.DepartmentName === value?.DepartmentName
              ) || {}
            ).DepartmentID || null,
          DepartmentName: value?.DepartmentName
        },
        SubscriptionFee: {
          Yearly: Number(value?.SubscriptionFeeYearly),
          Monthly: Number(value?.SubscriptionFeeMonthly)
        },
        Status: value?.PermitStatus,
        Description: value?.PermitDescription
      };
    } else {
      payload = {
        PermitID: departmentAction?.PermitID,
        SubscriptionFee: {
          Yearly: Number(value?.SubscriptionFeeYearly),
          Monthly: Number(value?.SubscriptionFeeMonthly)
        },
        Status: value?.PermitStatus,
        ChangeReason: 'Admin',
        Description: value?.PermitDescription
      };
    }

    try {
      const response = await httpRequest(
        `${departmentAction === 'Add' ? 'POST' : 'PATCH'}`,
        `${
          departmentAction === 'Add'
            ? `/townships/department_add`
            : `/townships/department_update`
        }`,
        payload
      );

      if (response?.status === 'success') {
        toast.success(
          `Department ${
            departmentAction === 'Add' ? 'added' : 'details updated'
          } successfully!`
        );
        setDepartmentAction('');
        handleApiCall();
      } else if (response?.type === 'NETWORK_ERROR') {
        toast.error('Network error. Please try again.');
      } else {
        toast.error(response?.message || 'Failed to add department.');
      }
    } catch (error) {
      toast.error('Failed to add department. Please try again.');
    }
  }

  // Handle cancel button
  function handleCancel() {
    setDepartmentAction('');
  }

  return (
    <Card>
      <Box m={3}>
        <FormikForm
          allFields={allFields}
          buttonTitle={['Cancel', 'Save']}
          fullScreen={false}
          isEditModel={false}
          content={false}
          buttonPlacement={'right'}
          formMethod={handleSubmit}
          handleOtherButton={handleCancel}
        />
      </Box>
    </Card>
  );
};

export default AddDepartment;
